import SearchBar from '@/common/SearchBar';
import HeaderAccountItem from '@/sem/PageHeader/HeaderAccountItem';
import HeaderMenuModal from '@/sem/PageHeader/HeaderMenuModal';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useConsumer } from '~/context/common/StaticContext';
import { useShowFinance } from '~/context/sem/StaticContext';
import AccountModal from './AccountModal';
import Logo from './Logo';
import { Container, Link, Links } from './PageHeader.styles';

export default function PageHeader() {
  const isMobile = useIsMobile();
  const showFinance = useShowFinance();
  const consumer = useConsumer();

  return (
    <>
      <Container>
        <a href="/" className="flex" data-analytics-id="Header - Home">
          <Logo iconOnly={isMobile} />
        </a>

        <Links>
          <Link href="/cars" data-analytics-id="Header - Search Cars">
            Search Cars
          </Link>

          <Link href="/sell-my-car" data-analytics-id="Header - Sell/Trade">
            Sell/Trade
          </Link>

          {showFinance && (
            <Link
              href="/financing-prequalification"
              data-analytics-id="Header - Get Financing"
            >
              Get Financing
            </Link>
          )}
        </Links>

        <SearchBar background="gray" button="small" consumer={consumer} />

        <div>
          <HeaderAccountItem />
        </div>
      </Container>
      <AccountModal />
      <HeaderMenuModal />
    </>
  );
}
